import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (

      <div className="py-6 container launchpad-page">
        <div className="launchpad-title">
          <h1>Current Presales</h1>
        </div>
        <div className="ant-tabs ant-tabs-top ant-tabs-large ant-tabs-centered">
          <div role="tablist" className="ant-tabs-nav">
            <div className="ant-tabs-nav-wrap">
              <div className="ant-tabs-nav-list" style={{ transform: "translate(0px, 0px)" }}>
                <div className="ant-tabs-tab ant-tabs-tab-active">
                  <div role="tab" aria-selected="true" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-all" aria-controls="rc-tabs-0-panel-all">All launchpads </div>
                </div>
                <div className="ant-tabs-tab">
                  <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-advanced" aria-controls="rc-tabs-0-panel-advanced">
                    Advanced Mode</div>
                </div>
                <div className="ant-tabs-tab">
                  <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-my" aria-controls="rc-tabs-0-panel-my">My Contributions </div>
                </div>
                <div className="ant-tabs-ink-bar ant-tabs-ink-bar-animated" style={{ left: "0px", width: "103px" }}></div>
              </div>
            </div>
            <div className="ant-tabs-nav-operations ant-tabs-nav-operations-hidden"><button type="button" className="ant-tabs-nav-more" tabindex="-1" aria-hidden="true" aria-haspopup="listbox" aria-controls="rc-tabs-0-more-popup" id="rc-tabs-0-more" aria-expanded="false" style={{ visibility: "hidden", order: "1" }}><span role="img"
              aria-label="ellipsis" className="anticon anticon-ellipsis"><svg
                viewBox="64 64 896 896" focusable="false" data-icon="ellipsis"
                width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path
                  d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z">
                </path>
              </svg></span></button></div>
          </div>
          <div className="ant-tabs-content-holder">
            <div className="ant-tabs-content ant-tabs-content-top">
              <div role="tabpanel" tabindex="0" aria-hidden="false" className="ant-tabs-tabpane ant-tabs-tabpane-active" id="rc-tabs-0-panel-all" aria-labelledby="rc-tabs-0-tab-all">
                <div className="pool-filter">
                  <div className="search">
                    <div className="filter-title invisible">s</div><span className="ant-input-affix-wrapper" style={{ borderRadius: "16px" }}><input
                      placeholder="Enter token name or token symbol" type="text"
                      className="ant-input" value="" /><span className="ant-input-suffix"><span
                        role="button" aria-label="close-circle" tabindex="-1"
                        className="anticon anticon-close-circle ant-input-clear-icon-hidden ant-input-clear-icon"><svg
                          viewBox="64 64 896 896" focusable="false"
                          data-icon="close-circle" width="1em" height="1em"
                          fill="currentColor" aria-hidden="true">
                          <path
                            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z">
                          </path>
                        </svg></span></span>
                    </span>
                  </div>
                  <div className="filter">
                    <div className="status">
                      <div className="filter-title">Filter By</div>
                      <div className="ant-select ant-select-single ant-select-show-arrow" style={{ width: "110px" }}>
                        <div className="ant-select-selector"><span className="ant-select-selection-search"><input
                          autocomplete="off" type="search"
                          className="ant-select-selection-search-input"
                          role="combobox" aria-haspopup="listbox"
                          aria-owns="rc_select_0_list"
                          aria-autocomplete="list"
                          aria-controls="rc_select_0_list"
                          aria-activedescendant="rc_select_0_list_0"
                          readonly="" unselectable="on" value=""
                          style={{ opacity: "0" }} id="rc_select_0" /></span><span className="ant-select-selection-item" title="All Status">All
                            Status</span></div><span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: "none" }}><span role="img"
                              aria-label="down"
                              className="anticon anticon-down ant-select-suffix"><svg
                                viewBox="64 64 896 896" focusable="false"
                                data-icon="down" width="1em" height="1em"
                                fill="currentColor" aria-hidden="true">
                                <path
                                  d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z">
                                </path>
                              </svg></span></span>
                      </div>
                    </div>
                    <div>
                      <div className="filter-title">Sort By</div>
                      <div className="ant-select ant-select-single ant-select-show-arrow" style={{ width: "110px" }}>
                        <div className="ant-select-selector"><span className="ant-select-selection-search"><input
                          autocomplete="off" type="search"
                          className="ant-select-selection-search-input"
                          role="combobox" aria-haspopup="listbox"
                          aria-owns="rc_select_1_list"
                          aria-autocomplete="list"
                          aria-controls="rc_select_1_list"
                          aria-activedescendant="rc_select_1_list_0"
                          readonly="" unselectable="on" value=""
                          style={{ opacity: "0" }} id="rc_select_1" /></span><span className="ant-select-selection-item" title="No Filter">No
                            Filter</span></div><span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: "none" }}><span role="img"
                              aria-label="down"
                              className="anticon anticon-down ant-select-suffix"><svg
                                viewBox="64 64 896 896" focusable="false"
                                data-icon="down" width="1em" height="1em"
                                fill="currentColor" aria-hidden="true">
                                <path
                                  d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z">
                                </path>
                              </svg></span></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="columns is-multiline">
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                        <div className="card-content is-flex-grow-1">
                          <div className="media is-flex is-align-items-center">
                            <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                              <p className="image is-56x56"><img src="https://riseofbusd.com/assets/webMainLogoOp.21af0deb.png" alt="" style={{ filter: "grayscale(0)" }} /></p>
                            </figure>
                            <div className="media-content">
                              <div className="is-flex is-justify-content-flex-end">
                                <div className="is-flex has-text-right is-flex-direction-column">
                                  <div>
                                    <div className="mr-2">
                                      <div style={{ display: "inlineBlock" }}>
                                        <span className="is-flex status-dot incoming"><svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 16 16"
                                          height="1em" width="1em"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="8" cy="8"
                                            r="8"></circle>
                                        </svg><span
                                          style={{ whiteSpace: "nowrap" }}>Upcoming</span></span>
                                      </div>
                                    </div>
                                    <div className="is-flex mt-2"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="content-title">
                            <p className="title">Rise of BUSD</p>
                            <p className="subtitle">1 BNB = 11,000,000,000 rBUSD</p>
                          </div>
                          <div className="soft-hard-cap">
                            <p>Soft/Hard </p><span>30 BNB - 60 BNB</span>
                          </div>
                          <div className="content-progress">
                            <p className="title">Progress (0.00%)</p>
                            <div className="ant-progress ant-progress-line ant-progress-status-normal ant-progress-default" style={{ marginTop: "-4px" }}>
                              <div className="ant-progress-outer">
                                <div className="ant-progress-inner">
                                  <div className="ant-progress-bg" style={{ width: "0%", height: "8px", background: "rgb(72, 199, 116)" }}>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="sub-title is-flex is-align-items-center">
                              <div className="is-flex-grow-1">0 BNB</div>
                              <div className="is-flex-grow-1 has-text-right">60 BNB
                              </div>
                            </div>
                          </div>
                          <div className="liquidity-percent">
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Liquidity %:</p><span className="is-flex-grow-1 has-text-right time-text">60%
                              </span>
                            </div>
                          </div>
                          <div className="lockup-time" style={{ margin: "0px 0px 0.25rem" }}>
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Lockup Time:</p><span className="is-flex-grow-1 has-text-right time-text">400
                                days</span>
                            </div>
                          </div>
                          <div className="custom-card-footer">
                            <div className="is-flex is-align-items-center">
                              <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                <div>Sale Starts In:</div>
                                <div className="countdown-text">
                                  <strong><span>01</span><span
                                    className="dotdot">:</span><span>01</span><span
                                      className="dotdot">:</span><span>40</span><span
                                        className="dotdot">:</span><span>38</span></strong>
                                </div>
                              </div>
                              <div className="view-pool has-text-right">
                                <div className="is-flex is-align-items-center">
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Click to receive notification when pool start">
                                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M289.7 403c-6.1 0-11.4 4.2-12.7 10.2-1 4.5-2.7 8.2-5 10.9-1.3 1.5-5.1 5.9-16.1 5.9-11 0-14.8-4.5-16.1-5.9-2.3-2.7-4-6.4-5-10.9-1.3-6-6.6-10.2-12.7-10.2-8.4 0-14.5 7.8-12.7 15.9 5 22.3 21 37.1 46.5 37.1s41.5-14.7 46.5-37.1c1.8-8.1-4.4-15.9-12.7-15.9zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.3-10.8-24.6-24-24.6h-.6c-13.2 0-24 11.3-24 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.1 0 25.4-18.8 15.6-31.8zm-39 5.8H139.8c-3.8 0-5.8-4.4-3.3-7.3 7-8 14.7-18.5 21-33.4 9.6-22.6 14.3-51.5 14.3-88.2 0-37.3 7-66.5 20.9-86.8 12.4-18.2 27.9-25.1 38.7-27.6 8.4-2 14.4-5.8 18.6-10.5 3.2-3.6 8.7-3.8 11.9-.2 5.1 5.7 12 9.1 18.8 10.7 10.8 2.5 26.3 9.4 38.7 27.6 13.9 20.3 20.9 49.5 20.9 86.8 0 36.7 4.7 65.6 14.3 88.2 6.5 15.2 14.4 25.9 21.5 33.9 2.2 2.7.4 6.8-3.1 6.8z">
                                        </path>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Add to favorite" style={{ lineHeight: "36px" }}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd"
                                        d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 01.176-.17C12.72-3.042 23.333 4.867 8 15z"
                                        clip-rule="evenodd"></path>
                                    </svg></div>
                                  </div><a className="view-button" href="/launchpad/0x2CF91ea18E72D7Fc5C34d19d800443dcA542f910?chain=BSC">View</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                        <div className="card-content is-flex-grow-1">
                          <div className="media is-flex is-align-items-center">
                            <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                              <p className="image is-56x56"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668612635547-b6827d3eb884f64706de1ae29ac4310b.png" alt="" style={{ filter: "grayscale(0)" }} /></p>
                            </figure>
                            <div className="media-content">
                              <div className="is-flex is-justify-content-flex-end">
                                <div className="is-flex has-text-right is-flex-direction-column">
                                  <div>
                                    <div className="mr-2">
                                      <div style={{ display: "inlineBlock" }}>
                                        <span className="is-flex status-dot incoming"><svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 16 16"
                                          height="1em" width="1em"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="8" cy="8"
                                            r="8"></circle>
                                        </svg><span
                                          style={{ whiteSpace: "nowrap" }}>Upcoming</span></span>
                                      </div>
                                    </div>
                                    <div className="is-flex mt-2"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="content-title">
                            <p className="title">Elon World Cup</p>
                            <p className="subtitle">Fair Launch</p>
                          </div>
                          <div className="soft-hard-cap">
                            <p>Soft </p><span>120 BNB</span>
                          </div>
                          <div className="content-progress">
                            <p className="title">Progress (0.00%)</p>
                            <div className="ant-progress ant-progress-line ant-progress-status-normal ant-progress-default" style={{ marginTop: "-4px" }}>
                              <div className="ant-progress-outer">
                                <div className="ant-progress-inner">
                                  <div className="ant-progress-bg" style={{ width: "0%", height: "8px", background: "rgba(72, 199, 116, 0.5)" }}>
                                  </div>
                                  <div className="ant-progress-success-bg" style={{ width: "0%", height: "8px", backgroundColor: "rgb(72, 199, 116)" }}>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="sub-title is-flex is-align-items-center">
                              <div className="is-flex-grow-1">0 BNB</div>
                              <div className="is-flex-grow-1 has-text-right">120 BNB
                              </div>
                            </div>
                          </div>
                          <div className="liquidity-percent">
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Liquidity %:</p><span className="is-flex-grow-1 has-text-right time-text">55%
                              </span>
                            </div>
                          </div>
                          <div className="lockup-time" style={{ margin: "0px 0px 0.25rem" }}>
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Lockup Time:</p><span className="is-flex-grow-1 has-text-right time-text">365
                                days</span>
                            </div>
                          </div>
                          <div className="custom-card-footer">
                            <div className="is-flex is-align-items-center">
                              <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                <div>Sale Starts In:</div>
                                <div className="countdown-text">
                                  <strong><span>01</span><span
                                    className="dotdot">:</span><span>01</span><span
                                      className="dotdot">:</span><span>40</span><span
                                        className="dotdot">:</span><span>38</span></strong>
                                </div>
                              </div>
                              <div className="view-pool has-text-right">
                                <div className="is-flex is-align-items-center">
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Click to receive notification when pool start">
                                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M289.7 403c-6.1 0-11.4 4.2-12.7 10.2-1 4.5-2.7 8.2-5 10.9-1.3 1.5-5.1 5.9-16.1 5.9-11 0-14.8-4.5-16.1-5.9-2.3-2.7-4-6.4-5-10.9-1.3-6-6.6-10.2-12.7-10.2-8.4 0-14.5 7.8-12.7 15.9 5 22.3 21 37.1 46.5 37.1s41.5-14.7 46.5-37.1c1.8-8.1-4.4-15.9-12.7-15.9zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.3-10.8-24.6-24-24.6h-.6c-13.2 0-24 11.3-24 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.1 0 25.4-18.8 15.6-31.8zm-39 5.8H139.8c-3.8 0-5.8-4.4-3.3-7.3 7-8 14.7-18.5 21-33.4 9.6-22.6 14.3-51.5 14.3-88.2 0-37.3 7-66.5 20.9-86.8 12.4-18.2 27.9-25.1 38.7-27.6 8.4-2 14.4-5.8 18.6-10.5 3.2-3.6 8.7-3.8 11.9-.2 5.1 5.7 12 9.1 18.8 10.7 10.8 2.5 26.3 9.4 38.7 27.6 13.9 20.3 20.9 49.5 20.9 86.8 0 36.7 4.7 65.6 14.3 88.2 6.5 15.2 14.4 25.9 21.5 33.9 2.2 2.7.4 6.8-3.1 6.8z">
                                        </path>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Add to favorite" style={{ lineHeight: "36px" }}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd"
                                        d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 01.176-.17C12.72-3.042 23.333 4.867 8 15z"
                                        clip-rule="evenodd"></path>
                                    </svg></div>
                                  </div><a className="view-button" href="/launchpad/0x37409a9d8e42C6B77FDCed216e06ac9D183EcAa7?chain=BSC">View</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                        <div className="card-content is-flex-grow-1">
                          <div className="media is-flex is-align-items-center">
                            <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                              <p className="image is-56x56"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668627508683-09dd8c2662b96ce14928333f055c5580.png" alt="" style={{ filter: "grayscale(0)" }} /></p>
                            </figure>
                            <div className="media-content">
                              <div className="is-flex is-justify-content-flex-end">
                                <div className="is-flex has-text-right is-flex-direction-column">
                                  <div>
                                    <div className="mr-2">
                                      <div style={{ display: "inlineBlock" }}>
                                        <span className="is-flex status-dot incoming"><svg
                                          stroke="currentColor"
                                          fill="currentColor"
                                          stroke-width="0"
                                          viewBox="0 0 16 16"
                                          height="1em" width="1em"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="8" cy="8"
                                            r="8"></circle>
                                        </svg><span
                                          style={{ whiteSpace: "nowrap" }}>Upcoming</span></span>
                                      </div>
                                    </div>
                                    <div className="is-flex mt-2"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="content-title">
                            <p className="title">QatarGrow</p>
                            <p className="subtitle">1 BNB = 2,300,000 QatarGrow</p>
                          </div>
                          <div className="soft-hard-cap">
                            <p>Soft/Hard </p><span>100 BNB - 200 BNB</span>
                          </div>
                          <div className="content-progress">
                            <p className="title">Progress (0.00%)</p>
                            <div className="ant-progress ant-progress-line ant-progress-status-normal ant-progress-default" style={{ marginTop: "-4px" }}>
                              <div className="ant-progress-outer">
                                <div className="ant-progress-inner">
                                  <div className="ant-progress-bg" style={{ width: "0%", height: "8px", background: "rgb(72, 199, 116)" }}>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="sub-title is-flex is-align-items-center">
                              <div className="is-flex-grow-1">0 BNB</div>
                              <div className="is-flex-grow-1 has-text-right">200 BNB
                              </div>
                            </div>
                          </div>
                          <div className="liquidity-percent">
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Liquidity %:</p><span className="is-flex-grow-1 has-text-right time-text">60%
                              </span>
                            </div>
                          </div>
                          <div className="lockup-time" style={{ margin: "0px 0px 0.25rem" }}>
                            <div className="is-flex is-align-items-center">
                              <p className="is-flex-grow-1">Lockup Time:</p><span className="is-flex-grow-1 has-text-right time-text">365
                                days</span>
                            </div>
                          </div>
                          <div className="custom-card-footer">
                            <div className="is-flex is-align-items-center">
                              <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                <div>Sale Starts In:</div>
                                <div className="countdown-text">
                                  <strong><span>02</span><span
                                    className="dotdot">:</span><span>03</span><span
                                      className="dotdot">:</span><span>40</span><span
                                        className="dotdot">:</span><span>38</span></strong>
                                </div>
                              </div>
                              <div className="view-pool has-text-right">
                                <div className="is-flex is-align-items-center">
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Click to receive notification when pool start">
                                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M289.7 403c-6.1 0-11.4 4.2-12.7 10.2-1 4.5-2.7 8.2-5 10.9-1.3 1.5-5.1 5.9-16.1 5.9-11 0-14.8-4.5-16.1-5.9-2.3-2.7-4-6.4-5-10.9-1.3-6-6.6-10.2-12.7-10.2-8.4 0-14.5 7.8-12.7 15.9 5 22.3 21 37.1 46.5 37.1s41.5-14.7 46.5-37.1c1.8-8.1-4.4-15.9-12.7-15.9zM412 352.2c-15.4-20.3-45.7-32.2-45.7-123.1 0-93.3-41.2-130.8-79.6-139.8-3.6-.9-6.2-2.1-6.2-5.9v-2.9c0-13.3-10.8-24.6-24-24.6h-.6c-13.2 0-24 11.3-24 24.6v2.9c0 3.7-2.6 5-6.2 5.9-38.5 9.1-79.6 46.5-79.6 139.8 0 90.9-30.3 102.7-45.7 123.1-9.9 13.1-.5 31.8 15.9 31.8h280.1c16.1 0 25.4-18.8 15.6-31.8zm-39 5.8H139.8c-3.8 0-5.8-4.4-3.3-7.3 7-8 14.7-18.5 21-33.4 9.6-22.6 14.3-51.5 14.3-88.2 0-37.3 7-66.5 20.9-86.8 12.4-18.2 27.9-25.1 38.7-27.6 8.4-2 14.4-5.8 18.6-10.5 3.2-3.6 8.7-3.8 11.9-.2 5.1 5.7 12 9.1 18.8 10.7 10.8 2.5 26.3 9.4 38.7 27.6 13.9 20.3 20.9 49.5 20.9 86.8 0 36.7 4.7 65.6 14.3 88.2 6.5 15.2 14.4 25.9 21.5 33.9 2.2 2.7.4 6.8-3.1 6.8z">
                                        </path>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="pr-1 is-flex is-align-items-center">
                                    <div className="subscription-bell is-clickable" title="Add to favorite" style={{ lineHeight: "36px" }}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd"
                                        d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 01.176-.17C12.72-3.042 23.333 4.867 8 15z"
                                        clip-rule="evenodd"></path>
                                    </svg></div>
                                  </div><a className="view-button" href="/launchpad/0xEc835588D173f7279Be97d7e81038a2b8d4b4a27?chain=BSC">View</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                  <div className="PoolNgItem_root__2cniO">
                    <div className="lazyload-wrapper " style={{ height: "100%" }}>
                      <div className="lazyload-placeholder" style={{ height: "419px" }}></div>
                    </div>
                  </div>
                </div>
                <div className="has-text-centered mt-2">
                  <div>
                    <div className="ant-spin ant-spin-spinning"><span className="ant-spin-dot ant-spin-dot-spin"><i
                      className="ant-spin-dot-item"></i><i
                        className="ant-spin-dot-item"></i><i
                          className="ant-spin-dot-item"></i><i
                            className="ant-spin-dot-item"></i></span></div>
                  </div>
                </div>
              </div>
              <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-advanced" aria-labelledby="rc-tabs-0-tab-advanced"></div>
              <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-my" aria-labelledby="rc-tabs-0-tab-my"></div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
